import { render, staticRenderFns } from "./EditParticipantInfo.vue?vue&type=template&id=05963f83&scoped=true&"
import script from "./EditParticipantInfo.vue?vue&type=script&lang=js&"
export * from "./EditParticipantInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditParticipantInfo.vue?vue&type=style&index=0&id=05963f83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05963f83",
  null
  
)

export default component.exports